<template>
    <div>
        <div class="modal-header">
            <h5 class="modal-title">Add Node Server</h5>
            <button type="button" class="close" @click="$modal.hide('new_node_server')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <form @submit.prevent="submitForm">
                <div class="form-group">
                    <label for="url">URL *</label>
                    <input type="url" class="form-control" id="url" v-model="form.url" 
                           placeholder="Enter server URL (e.g., https://example.com)" required>
                </div>
                
                <div class="form-group">
                    <label for="token">Token *</label>
                    <input type="text" class="form-control" id="token" v-model="form.token" 
                           placeholder="Enter authentication token" required>
                </div>
                
                <div class="form-group">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="multidevice" v-model="form.multidevice">
                        <label class="form-check-label" for="multidevice">
                            Multi Device Support
                        </label>
                    </div>
                </div>
                
                <div class="form-group">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="dev_only" v-model="form.dev_only">
                        <label class="form-check-label" for="dev_only">
                            Development Only
                        </label>
                    </div>
                </div>
                
                <div class="form-group">
                    <div class="form-check">
                        <input type="checkbox" class="form-check-input" id="hide" v-model="form.hide">
                        <label class="form-check-label" for="hide">
                            Hide Server
                        </label>
                    </div>
                </div>
                
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="$modal.hide('new_node_server')">
                        Cancel
                    </button>
                    <button type="submit" class="btn btn-primary" :disabled="loading">
                        <span v-if="loading" class="spinner-border spinner-border-sm mr-2"></span>
                        {{ loading ? 'Creating...' : 'Create Node Server' }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            form: {
                url: '',
                token: '',
                multidevice: false,
                dev_only: false,
                hide: false
            }
        };
    },
    methods: {
        async submitForm() {
            this.loading = true;
            
            try {
                // Convert boolean values to integers for API
                const formData = {
                    ...this.form,
                    multidevice: this.form.multidevice ? 1 : 0,
                    dev_only: this.form.dev_only ? 1 : 0,
                    hide: this.form.hide ? 1 : 0,
                };
                
                await this.$store.dispatch('admin_node_server_create', formData);
                this.$toast.success('Node server created successfully');
                this.$modal.hide('new_node_server');
                this.$root.$emit('refresh_table');
                this.resetForm();
            } catch (err) {
                this.$toast.error(err.response?.data?.message || 'Failed to create node server');
                console.error(err);
            } finally {
                this.loading = false;
            }
        },
        resetForm() {
            this.form = {
                server_uuid: '',
                url: '',
                token: '',
                multidevice: false,
                dev_only: false,
                hide: false
            };
        }
    }
};
</script>

<style scoped>
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1rem;
    border-bottom: 1px solid #dee2e6;
}

.modal-title {
    margin: 0;
    font-size: 1.25rem;
}

.close {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
}

.modal-body {
    padding: 1rem;
}

.modal-footer {
    padding: 1rem;
    border-top: 1px solid #dee2e6;
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem;
}

.form-group {
    margin-bottom: 1rem;
}

.form-check {
    margin-bottom: 0.5rem;
}

.spinner-border-sm {
    width: 1rem;
    height: 1rem;
}
</style>
